module.exports = __webpack_public_path__ + "static/img/Script_Icon.157eec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Script_Icon.png
// module id = 1097
// module chunks = 21